import { EFeatures, ERoles } from '@constants';

import { InfoWidget } from '../components/InfoWidget';
import { LiveClassesWidget } from '../components/LiveClassesWidget';
import { OpenTicketsWidget } from '../components/OpenTicketsWidget';
import { PendingTasksWidget } from '../components/PendingTasksWidget';
import { PostWidget } from '../components/PostWidget';
import { ReportsWidget } from '../components/ReportsWidget';

import { WidgetProps } from '@/types';

type Props = Record<
  ERoles,
  {
    Widget: React.FC<WidgetProps>;
    position: { x: number; y: number; w: number; h: number };
    availableForFeature?: EFeatures;
  }[]
>;

export const WIDGETS: Props = {
  [ERoles.ADMIN]: [],
  [ERoles.MANAGER]: [
    { Widget: InfoWidget, position: { x: 0, y: 0, w: 6, h: 1 } },
    { Widget: PostWidget, position: { x: 6, y: 0, w: 5, h: 2 } },
    { Widget: ReportsWidget, position: { x: 0, y: 1, w: 6, h: 1 } }
  ],
  [ERoles.TEACHER]: [
    { Widget: PendingTasksWidget, position: { x: 0, y: 0, w: 12, h: 1 } },
    { Widget: LiveClassesWidget, position: { x: 0, y: 1, w: 6, h: 1.5 } },
    { Widget: OpenTicketsWidget, position: { x: 6, y: 1, w: 6, h: 1.5 } }
  ],
  [ERoles.STUDENT]: [],
  [ERoles.SALES]: [{ Widget: InfoWidget, position: { x: 0, y: 0, w: 6, h: 1 } }],
  [ERoles.SUPPORT]: [{ Widget: InfoWidget, position: { x: 0, y: 0, w: 6, h: 1 } }],
  [ERoles.INSPECTOR]: [{ Widget: InfoWidget, position: { x: 0, y: 0, w: 6, h: 1 } }],
  [ERoles.AI_TEACHER]: []
};
